// src/components/ProgressIndicator.jsx
import React from "react";
import { useProgress } from "./contexts/ProgressContext";

export default function ProgressIndicator() {
  const { visible, percent, stepText, logs } = useProgress();

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed",
      top: 16,
      right: 16,
      width: 220,
      zIndex: 9999,
      background: "white",
      boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
      borderRadius: 8,
      padding: 12,
      fontSize: 13
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
        <strong>Progress</strong>
        <span>{percent}%</span>
      </div>

      <div style={{ height: 8, width: "100%", background: "#eee", borderRadius: 6, overflow: "hidden", marginBottom: 8 }}>
        <div style={{ width: `${percent}%`, height: "100%", background: "#6b46c1" }} />
      </div>

      <div style={{ fontSize: 12, color: "#333", marginBottom: 6 }}>{stepText}</div>

      {/* optional: short log preview */}
      {logs.length > 0 && (
        <div style={{ maxHeight: 80, overflow: "auto", fontSize: 11, color: "#444" }}>
          {logs.slice(-4).map((l, i) => <div key={i}>• {l}</div>)}
        </div>
      )}
    </div>
  );
}
